/**
 * House TTS engines — Standard Kokoro, Premium Breeze.
 * Dump GpuBrowser is off. Premium also unlocks the TTS filter.
 */

export type VoiceEngineTier = "standard" | "premium";

export type HouseVoice = { id: string; label: string };

export type HouseTtsEngine = {
  id: string;
  label: string;
  blurb: string;
  tier: VoiceEngineTier;
  memberOnly?: boolean;
  costPer1kCharsUsd: number;
  voices: HouseVoice[];
};

export const KOKORO_VOICES: HouseVoice[] = [
  { id: "af_heart", label: "Heart (F)" },
  { id: "af_bella", label: "Bella (F)" },
  { id: "af_sarah", label: "Sarah (F)" },
  { id: "af_nicole", label: "Nicole (F)" },
  { id: "am_adam", label: "Adam (M)" },
  { id: "am_michael", label: "Michael (M · narrator)" },
  { id: "am_fenrir", label: "Fenrir (M)" },
  { id: "bf_emma", label: "Emma (F UK)" },
  { id: "bm_george", label: "George (M UK)" },
];

export const BREEZE_VOICES: HouseVoice[] = [
  { id: "warm-narrator", label: "Warm narrator" },
  { id: "clear-woman", label: "Clear young woman" },
  { id: "restrained-man", label: "Restrained man" },
];

export const HOUSE_TTS_ENGINES: HouseTtsEngine[] = [
  {
    id: "forge/suite-kokoro",
    label: "Kokoro",
    blurb: "Standard suite TTS — vividlex-kokoro.",
    tier: "standard",
    costPer1kCharsUsd: 0.002,
    voices: KOKORO_VOICES,
  },
  {
    id: "forge/suite-breeze-tts",
    label: "Breeze",
    blurb: "Premium Breeze TTS 2 — voice design / direction. Needs Member.",
    tier: "premium",
    memberOnly: true,
    costPer1kCharsUsd: 0.02,
    voices: BREEZE_VOICES,
  },
];

export const DEFAULT_HOUSE_TTS_ID = "forge/suite-kokoro";
export const DEFAULT_HOUSE_VOICE = "af_heart";

export function houseTtsEngines(tier?: VoiceEngineTier): HouseTtsEngine[] {
  if (!tier) return HOUSE_TTS_ENGINES;
  return HOUSE_TTS_ENGINES.filter((e) => e.tier === tier);
}

export function getHouseTtsEngine(id: string | null | undefined): HouseTtsEngine | undefined {
  const raw = String(id || "").trim().toLowerCase();
  if (!raw) return undefined;
  if (raw.includes("breeze")) {
    return HOUSE_TTS_ENGINES.find((e) => e.tier === "premium");
  }
  if (raw.includes("kokoro") || raw === "forge/suite-kokoro") {
    return HOUSE_TTS_ENGINES.find((e) => e.tier === "standard");
  }
  return HOUSE_TTS_ENGINES.find((e) => e.id.toLowerCase() === raw);
}

export function resolveHouseTtsId(id: string | null | undefined): string {
  return getHouseTtsEngine(id)?.id || DEFAULT_HOUSE_TTS_ID;
}

export function isKokoroHouse(id: string): boolean {
  return getHouseTtsEngine(id)?.id === "forge/suite-kokoro";
}

export function isBreezeHouse(id: string): boolean {
  return getHouseTtsEngine(id)?.id === "forge/suite-breeze-tts";
}
